import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-estudos-bioritmo',
  templateUrl: './estudos-bioritmo.component.html',
  styleUrls: ['./estudos-bioritmo.component.css']
})
export class EstudosBioritmoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
